var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp-stack",attrs:{"data-test":"pp-tab-followups"}},[_c('PanelCard',{attrs:{"title":"Follow-ups","icon":"fa-bell-o","count":_vm.openCount ? `${_vm.openCount} open` : '—',"test-id":"pp-followups"}},[_c('FollowupList',{attrs:{"rows":_vm.followups,"date-format":_vm.dateFormat}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }